<template>
  <div>
    <label class="pl-2 v-label v-label--active theme--light" style="font-size: 1em" v-if="!!label">
      {{ label }}
    </label>
    <editor v-model="model" :init="init"/>
  </div>
</template>

<script>
import tinymce from 'tinymce';
import Editor from '@tinymce/tinymce-vue';

import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/themes/silver';
import 'tinymce/models/dom/model.min.js';
import 'tinymce/icons/default';
import 'tinymce/plugins/link';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis.js';
import 'tinymce-i18n/langs5/ru_RU';

export default {
  name: 'text-wysiwyg_editor_field',

  components: { Editor },

  props: {
    value: { type: String },
    label: { type: String, default: null }
  },

  emits: ['input'],

  data: () => ({
    init: {
      language: 'ru_RU',
      menubar: false,
      content_css: false,
      skin: false,
      height: 300,
      plugins: 'link autolink emoticons',
      toolbar: 'bold italic underline strikethrough | link | emoticons',
      branding: false,
      license_key: 'gpl',
      paste_data_images: false,
      paste_as_text: true,
      statusbar: false,
      formats: {
        underline: { inline: 'u' }
      },
      newline_behavior: 'linebreak',
      entity_encoding: 'raw'
    }
  }),

  computed: {
    model: {
      get () {
        return typeof this.value === 'string' ? this.value : '';
      },
      set (value) {
        this.$emit('input', value);
      }
    }
  },

  mounted () {
    tinymce.init({});
  }
};
</script>

<style>

.tox-tinymce {
  border-radius: 0px !important;
}

.tox .tox-edit-area::before {
  border: 2px solid #5AAE41 !important;
}

</style>
